import React from 'react';
import styled, { css } from 'styled-components';

export const Container = styled.div`
    position:relative;
    display: flex;
    justify-content: center;
    align-items: center;
`
export const Input = styled.input`
    width:100%;
    padding:.75rem 1rem;
    border: 1px solid #dadce0;
    border-radius: 4px;
    font-size: 1rem;
    outline-color: transparent;

    &:not(:placeholder-shown) + span,
    &:focus + span{
        transform:translateX(10px) translateY(-20px);
        font-size:0.75rem;
        font-weight: 600;
        padding:0 6px;
        background-color: #fff;
    }

    &:not(:focus) + span{
        color: #808080;
    }
    
`
export const Label = styled.span`
    position:absolute;
    left:0;
    padding-left:1.2rem;
    font-size:1rem;
    color:#7f8fa6;
    pointer-events: none;
    transition:all 0.25s;
`

